import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import AdditionalInfo from "./AdditionalInfo.jsx";
import CloseIcon from "@mui/icons-material/Close";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Global } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { mutateAdditionalInfoData } from "../utils/Mutates.js";
import { hideIntercom, showIntercom } from "../utils/Utils.js";

export default function MoreInfo(props) {
  const [openModal, setOpenModal] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [loading, setLoading] = useState(true);
  const event = props.eventProp;
  useEffect(() => {
    setLoading(false);
  }, [fullScreen]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navTabs = document.querySelector(".tabsContainer");

  if (openModal || openDrawer) {
    hideIntercom();
    if (navTabs) {
      navTabs.style.marginRight = "10px";
    }
    document.documentElement.style.overflow = "hidden";
    document.querySelector("body").style.marginRight = `10px`;
  } else {
    showIntercom();
    document.documentElement.style.overflow = "auto";
    document.querySelector("body").style.marginRight = `0px`;
    if (navTabs) {
      navTabs.style.marginRight = "0";
    }
  }

  const drawerBleeding = 88;
  const Root = styled("div")(({ theme }) => ({
    height: "100%",
  }));
  const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: "#fff",
  }));

  const Puller = styled(Box)(({ theme }) => ({
    width: 48,
    height: 4,
    backgroundColor: "#9897A9",
    borderRadius: 3,
    position: "absolute",
    top: 16,
    left: "calc(50% - 24px)",
  }));

  const destroyModal = () => {
    $("#modal").remove();
  };

  const handleOpen = () => {
    if (navTabs) {
      navTabs.style.marginRight = "10px";
    }
    if (fullScreen) {
      setOpenDrawer(true);
      setOpenModal(false);
    }
    if (!fullScreen) {
      setOpenModal(true);
      setOpenDrawer(false);
    }
    hideIntercom();
    document.documentElement.style.overflow = "hidden";
    document.querySelector("body").style.marginRight = `10px`;
  };

  const handleClose = () => {
    if (navTabs) {
      navTabs.style.marginRight = "0";
    }
    showIntercom();
    document.documentElement.style.overflow = "auto";
    document.querySelector("body").style.marginRight = `0px`;
    destroyModal();
    setOpenModal(false);
    setOpenDrawer(false);
  };

  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            maxHeight: `calc(100% - ${drawerBleeding}px)`,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            scrollbarColor: "#CFD1D1 transparent",
            "*::-webkit-scrollbar": {
              width: "7px",
            },
            "*::-webkit-scrollbar-track": {},
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: "#CFD1D1",
              borderRadius: "5px ",
            },
          },
          ".MuiDialog-paper": {
            scrollbarColor: "#CFD1D1 transparent",
            "*::-webkit-scrollbar": {
              width: "7px",
            },
            "*::-webkit-scrollbar-track": {},
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: "#CFD1D1",
              borderRadius: "5px ",
            },
          },
          ".MuiDialogTitle-root": {
            padding: "24px !important",
          },
        }}
      />
      <div>
        {fullScreen ? (
          <SwipeableDrawer
            anchor="bottom"
            open={openModal}
            onOpen={handleOpen}
            onClose={() => handleClose()}
            disableSwipeToOpen={true}
            disableScrollLock={false}
          >
            <StyledBox
              sx={{
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                right: 0,
                left: 0,
                pt: 2,
              }}
            >
              <Puller />
              <div className="r_drawerTitle">
                <SkeletonTheme
                  baseColor="#D8DBE0"
                  highlightColor="#EDF1F6"
                  borderRadius={"4px"}
                >
                  {loading ? (
                    <Skeleton wrapper={Box} width={160} height={31} />
                  ) : (
                    <div className="r_dialogTitleText" style={{fontSize: 16, marginBottom: 0}}>
                      {playdetailsv2_resources.AdditionalInfo}
                    </div>
                  )}
                </SkeletonTheme>
              </div>
            </StyledBox>
            <StyledBox
              sx={{
                px: 2,
                pb: 2,
                overflow: "auto",
              }}
            >
              <AdditionalInfo
                eventData={mutateAdditionalInfoData(event)}
                inModal={true}
                loading={loading}
                hasAdditionalInfoSection
              />
            </StyledBox>
          </SwipeableDrawer>
        ) : (
          <Dialog
            open={openModal}
            onOpen={handleOpen}
            onClose={() => handleClose()}
            aria-labelledby="responsive-dialog-title"
            PaperProps={{
              sx: {
                bgcolor: "white",
                maxWidth: "revert",
                width: 1212,
                borderRadius: "8px",
              },
            }}
          >
            <DialogTitle className="r_dialogTitle">
              {loading ? (
                <SkeletonTheme
                  baseColor="#D8DBE0"
                  highlightColor="#EDF1F6"
                  borderRadius={"4px"}
                >
                  <Skeleton wrapper={Box} width={160} height={31} />
                </SkeletonTheme>
              ) : (
                <div className="r_dialogTitleText">
                  {playdetailsv2_resources.AdditionalInfo}
                </div>
              )}
              <CloseIcon onClick={handleClose} className="r_dialogTitleIcon" />
            </DialogTitle>
            <DialogContent>
              <AdditionalInfo
                eventData={mutateAdditionalInfoData(event)}
                inModal={true}
                loading={loading}
                hasAdditionalInfoSection
              />
            </DialogContent>
          </Dialog>
        )}
      </div>
    </Root>
  );
}
